// Welke tekens een skill krijgt in het /-menu, de toverstaflijst en op zijn
// kaart. Zonder React, zodat vitest het zonder DOM draait.
//
// Systeemskills krijgen geen teken: dat zijn er altijd drie. Eigen skills
// kunnen er veel worden, en een duplicaat met bijna dezelfde naam moet te
// onderscheiden zijn van het origineel.

import { SkillMarks } from "./types";

export type SkillMarkKind = "organization" | "paid";

export interface SkillMark {
  kind: SkillMarkKind;
  title: string;
}

export const PAID_TITLE =
  "Kan geld kosten; je bevestigt het bedrag voordat er iets wordt opgevraagd";

export function skillMarks(skill: SkillMarks & { updatedBy?: string }): SkillMark[] {
  const marks: SkillMark[] = [];
  if (skill.organization) {
    marks.push({
      kind: "organization",
      title: skill.updatedBy
        ? `Skill van je organisatie · laatst bewerkt door ${skill.updatedBy}`
        : "Skill van je organisatie",
    });
  }
  if (skill.paid) marks.push({ kind: "paid", title: PAID_TITLE });
  return marks;
}
